import { useOutletContext } from "react-router-dom";
import { RecipeBook } from "@/components/recipes/RecipeBook";

export default function RecipesPage() {
  const { universe, canEdit } = useOutletContext();
  return (
    <div className="px-4 py-10 sm:px-8 lg:px-12" data-testid="recipes-page">
      <RecipeBook basePath={`/u/${universe.id}/recipes`} universeId={universe.id} canEdit={canEdit} eyebrow="Kitchen" title="Recipes" />
    </div>
  );
}
